import { api } from '@/services';
import { is401, getErrorDetails } from '@/utils';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID;
const GOOGLE_REDIRECT_URI = import.meta.env.VITE_GOOGLE_REDIRECT_URI;

const SCOPES = 'https://www.googleapis.com/auth/youtube.force-ssl';

export const login = async () => {
  const state = crypto.randomUUID();

  sessionStorage.setItem('youtube_auth_state', state);
  sessionStorage.setItem(
    'oauth_return_path',
    window.location.pathname + window.location.search
  );

  const authParams = new URLSearchParams({
    state,
    scope: SCOPES,
    prompt: 'consent',
    response_type: 'code',
    access_type: 'offline',
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: GOOGLE_REDIRECT_URI,
  });

  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${authParams.toString()}`;
};

export const handleCallback = async (searchParams) => {
  const error = searchParams.get('error');

  if (error) {
    console.error('YouTube auth error:', error);
    return;
  }

  const code = searchParams.get('code');
  const returnedState = searchParams.get('state');
  const storedState = sessionStorage.getItem('youtube_auth_state');

  sessionStorage.removeItem('youtube_auth_state');

  if (returnedState !== storedState) {
    console.error('Authorization state mismatch.');
    return;
  }

  await api.exchangeYouTubeCode(code);
};

export const refresh = async (updateAuthState, onUnauthorized) => {
  updateAuthState({ isSigningIn: true });

  try {
    const accounts = await api.getYouTubeStatus();

    updateAuthState({ accounts, isSigningIn: false, error: null });
  } catch (error) {
    const { is429, message } = getErrorDetails(error);

    if (is429) {
      updateAuthState({ isSigningIn: false, error: message });
      return;
    }

    updateAuthState({ accounts: [], isSigningIn: false });

    if (is401(error)) onUnauthorized();
  }
};

export const logout = async (updateAuthState, onUnauthorized, accountId) => {
  updateAuthState({ isSigningOut: true });

  try {
    await api.disconnectYouTubeAccount(accountId);
  } catch (error) {
    if (is401(error)) onUnauthorized();
  } finally {
    await refresh(updateAuthState, onUnauthorized);

    updateAuthState({ isSigningOut: false });
  }
};
